module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/Mundaka-87872fc672f0062d64d5432682424a0c.jpg";